var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',{staticStyle:{"display":"flex","align-items":"center"}},[_c('center',[_c('h1',[_vm._v("Unauthorized")]),_c('p',[_vm._v("You are not authorized to view this page.")]),_c('v-btn',{attrs:{"small":"","to":'/',"color":"primary"}},[_vm._v("Go to homepage")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }